"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The UserStatsMediaRequest model module.
 * @module model/UserStatsMediaRequest
 * @version 1.1.3-alpha.1
 */
class UserStatsMediaRequest {
  /**
   * Constructs a new <code>UserStatsMediaRequest</code>.
   * @alias module:model/UserStatsMediaRequest
   * @param media_ids {Array.<String>} The media ids to query for user stats
   */
  constructor(media_ids) {
    UserStatsMediaRequest.initialize(this, media_ids);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, media_ids) {
    obj['media_ids'] = media_ids;
  }

  /**
   * Constructs a <code>UserStatsMediaRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UserStatsMediaRequest} obj Optional instance to populate.
   * @return {module:model/UserStatsMediaRequest} The populated <code>UserStatsMediaRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new UserStatsMediaRequest();
      if (data.hasOwnProperty('media_ids')) {
        obj['media_ids'] = _ApiClient.default.convertToType(data['media_ids'], ['String']);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>UserStatsMediaRequest</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UserStatsMediaRequest</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of UserStatsMediaRequest.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is an array
    if (!Array.isArray(data['media_ids'])) {
      throw new Error("Expected the field `media_ids` to be an array in the JSON data but got " + data['media_ids']);
    }
    return true;
  }
}
UserStatsMediaRequest.RequiredProperties = ["media_ids"];

/**
 * The media ids to query for user stats
 * @member {Array.<String>} media_ids
 */
UserStatsMediaRequest.prototype['media_ids'] = undefined;
var _default = exports.default = UserStatsMediaRequest;